"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deriveViewableInformationFromPushPinData = void 0;
var _urnUtils = require("../utils/data/urnUtils");
const deriveViewableInformationFromPushPinData = data => {
  var _data$objectData;
  if (!data || !data.seedURN) {
    return;
  }
  const urn = (0, _urnUtils.decodeUrn)(data.seedURN);
  const lineageUrnAndVersion = (0, _urnUtils.getLineageUrnAndVersion)(urn);
  if (!lineageUrnAndVersion) {
    return;
  }
  const {
    lineageUrn,
    versionNumber
  } = lineageUrnAndVersion;
  const viewableId = (_data$objectData = data.objectData) === null || _data$objectData === void 0 ? void 0 : _data$objectData.viewableId;
  return {
    lineageUrn,
    versionNumber,
    viewableId
  };
};
exports.deriveViewableInformationFromPushPinData = deriveViewableInformationFromPushPinData;
//# sourceMappingURL=DeriveViewableInformationFromPushPinData.js.map